// extracted by mini-css-extract-plugin
module.exports = {"beneficiary-container":"ExternalBeneficiary_beneficiary-container__PO2Di","group":"ExternalBeneficiary_group__1ojxL"};